import React, { useState } from 'react';
import { FileText, ExternalLink, Calendar, MapPin, History, Edit, Trash2 } from 'lucide-react';
import SEO from '../../../common/SEO';
import ConferenceNav from '../../../common/ConferenceNav';
import NewFooter from '../../../common/NewFooter';

const ConferenceProceedings = () => {
  const [selectedConference, setSelectedConference] = useState(0);
  const [currentPage] = useState('main');


  const [pastConferences, setPastConferences] = useState([
    {
      id: 1,
      name: "AI & Machine Learning Summit 2023",
      year: "2023",
      location: "San Francisco, USA",
      date: "March 15-17, 2023",
      description: "Advanced artificial intelligence and machine learning research presentations.",
      status: "Completed"
    },
    {
      id: 2,
      name: "Digital Innovation Conference 2022",
      year: "2022", 
      location: "Berlin, Germany",
      date: "September 8-10, 2022",
      description: "Exploring digital transformation and innovation strategies.",
      status: "Completed"
    }
  ]);
  const [editingConference, setEditingConference] = useState(null);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [newConference, setNewConference] = useState({
    name: '',
    year: '',
    location: '',
    date: '',
    description: '',
    status: 'Completed'
  });

  // Sample conference data - replace with your actual data
  const conferences = [
    {
      "id": 2,
      "name": "AIC-RAETHM 2025",
      "year": "2025",
      "location": "India",
      "date": "January 10-11, 2025",
      "description": "A premier platform bringing together researchers, academicians, and industry professionals to discuss recent advances in engineering technology, healthcare, and management.",
      "proceedings": {
        "summary": {
          "title": "Conference Summary",
          "description": "Comprehensive overview of keynote addresses, technical sessions, and panel discussions.",
          "pdfLink": "/proceedings/aic-raethm2025/summary.pdf",
          "paperLink": "/ConferencePapers/AIC-RAETHM2025"
        },
        "abstracts": {
          "title": "Abstract Book", 
          "description": "Compilation of all research abstracts and detailed findings presented at the conference",
          "pdfLink": "/client/src/assets/Pdf/Abstract Book(Final Book).pdf",
          "paperLink": "/ConferencePapers"
        }
      }
    },
    {
      id: 2,
      name: "Upcoming Conference 1",
      // location: "London, UK",
      // date: "June 10-12, 2024",
      description: "Exploring the future of technology and innovation",
      proceedings: {
        summary: {
          title: "Conference Summary",
          description: "Overview of all sessions",
          pdfLink: "/proceedings/tech2024/summary.pdf",
          paperLink: "/ConferencePapers"
        },
        abstracts: {
          title: "Abstract Book",
          description: "Compilation of all abstracts", 
          pdfLink: "/proceedings/tech2024/abstracts.pdf",
          paperLink: "/ConferencePapers"
        }
      }
    },
    {
      id: 3,
      name: "Upcoming Conference 2",
      // location: "Tokyo, Japan",
      description: "Advanced data science methodologies and applications",
      proceedings: {
        summary: {
          title: "Conference Summary",
          description: "Overview of all sessions",
          pdfLink: "/proceedings/data2025/summary.pdf",
          paperLink: "/ConferencePapers"
        },
        abstracts: {
          title: "Abstract Book",
          description: "Compilation of all abstracts",
          pdfLink: "/proceedings/data2025/abstracts.pdf", 
          paperLink: "/conference-papers"
        }
      }
    }
  ];

  const currentConference = conferences[selectedConference];

  const handlePastConferencesClick = () => {
    // Navigate to past conferences route
    window.location.href = '/past-conference';
    // Or if using React Router: navigate('/past-conferences');
  };

  const handleAddConference = () => {
    if (newConference.name && newConference.location && newConference.date) {
      const newId = Math.max(...pastConferences.map(c => c.id), 0) + 1;
      setPastConferences([...pastConferences, { ...newConference, id: newId }]);
      setNewConference({
        name: '',
        year: '',
        location: '',
        date: '',
        description: '',
        status: 'Completed'
      });
      setIsAddingNew(false);
    }
  };

  const handleEditConference = (conference) => {
    setEditingConference({ ...conference });
  };

  const handleSaveEdit = () => {
    setPastConferences(pastConferences.map(conf => 
      conf.id === editingConference.id ? editingConference : conf
    ));
    setEditingConference(null);
  };

  const handleDeleteConference = (id) => {
    setPastConferences(pastConferences.filter(conf => conf.id !== id));
  };

  if (currentPage === '/PastConference') {
    return (
      <>
        <ConferenceNav />
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 pt-28 pb-12 px-4">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          

          {/* Add New Conference Form */}
          {isAddingNew && (
            <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Add New Conference</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="Conference Name"
                  value={newConference.name}
                  onChange={(e) => setNewConference({...newConference, name: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
                <input
                  type="text"
                  placeholder="Year"
                  value={newConference.year}
                  onChange={(e) => setNewConference({...newConference, year: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
                <input
                  type="text"
                  placeholder="Location"
                  value={newConference.location}
                  onChange={(e) => setNewConference({...newConference, location: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
                <input
                  type="text"
                  placeholder="Date"
                  value={newConference.date}
                  onChange={(e) => setNewConference({...newConference, date: e.target.value})}
                  className="p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                />
              </div>
              <textarea
                placeholder="Description"
                value={newConference.description}
                onChange={(e) => setNewConference({...newConference, description: e.target.value})}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent mt-4"
                rows="3"
              />
              <div className="flex gap-4 mt-4">
                <button
                  onClick={handleAddConference}
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  Save Conference
                </button>
                <button
                  onClick={() => setIsAddingNew(false)}
                  className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg transition-colors"
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          {/* Past Conferences List */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {pastConferences.map((conference) => (
              <div key={conference.id} className="bg-white rounded-xl shadow-lg p-6">
                {editingConference && editingConference.id === conference.id ? (
                  // Edit Mode
                  <div className="space-y-4">
                    <input
                      type="text"
                      value={editingConference.name}
                      onChange={(e) => setEditingConference({...editingConference, name: e.target.value})}
                      className="w-full p-2 border border-gray-300 rounded-lg text-lg font-semibold"
                    />
                    <input
                      type="text"
                      value={editingConference.location}
                      onChange={(e) => setEditingConference({...editingConference, location: e.target.value})}
                      className="w-full p-2 border border-gray-300 rounded-lg"
                    />
                    <input
                      type="text"
                      value={editingConference.date}
                      onChange={(e) => setEditingConference({...editingConference, date: e.target.value})}
                      className="w-full p-2 border border-gray-300 rounded-lg"
                    />
                    <textarea
                      value={editingConference.description}
                      onChange={(e) => setEditingConference({...editingConference, description: e.target.value})}
                      className="w-full p-2 border border-gray-300 rounded-lg"
                      rows="3"
                    />
                    <div className="flex gap-2">
                      <button
                        onClick={handleSaveEdit}
                        className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded text-sm transition-colors"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => setEditingConference(null)}
                        className="bg-gray-500 hover:bg-gray-600 text-white px-3 py-1 rounded text-sm transition-colors"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  // View Mode
                  <>
                    <div className="flex justify-between items-start mb-4">
                      <h3 className="text-xl font-semibold text-gray-900">{conference.name}</h3>
                      <div className="flex gap-2">
                        <button
                          onClick={() => handleEditConference(conference)}
                          className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                        >
                          <Edit className="w-4 h-4 text-gray-600" />
                        </button>
                        <button
                          onClick={() => handleDeleteConference(conference.id)}
                          className="p-2 hover:bg-red-100 rounded-lg transition-colors"
                        >
                          <Trash2 className="w-4 h-4 text-red-600" />
                        </button>
                      </div>
                    </div>
                    
                    <div className="space-y-2 mb-4">
                      <div className="flex items-center text-sm text-gray-600">
                        <Calendar className="w-4 h-4 mr-2" />
                        <span>{conference.date}</span>
                      </div>
                      <div className="flex items-center text-sm text-gray-600">
                        <MapPin className="w-4 h-4 mr-2" />
                        <span>{conference.location}</span>
                      </div>
                    </div>
                    
                    <p className="text-gray-600 mb-4">{conference.description}</p>
                    
                    <div className="flex justify-between items-center">
                      <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                        {conference.status}
                      </span>
                      <div className="flex gap-2">
                        <button className="text-indigo-600 hover:text-indigo-700 text-sm font-medium">
                          View Proceedings →
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>

          {pastConferences.length === 0 && !isAddingNew && (
            <div className="text-center py-16">
              <History className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">No past conferences yet</h3>
              <p className="text-gray-500 mb-4">Add your first completed conference to get started.</p>
              <button
                onClick={() => setIsAddingNew(true)}
                className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg"
              >
                Add Conference
              </button>
            </div>
          )}
        </div>
      </div>
      <NewFooter />
    </>
    );
  }

  return (
    <>
      <ConferenceNav />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 pt-28 pb-12 px-4">
      <SEO 
        title="Conference Paper Writing Publication & Proceedings Bhopal"
        description="Access conference proceedings and Conference paper writing publication guidance, Research paper writing and publication, SCI paper writing bhopal, and IEEE paper writing."
        canonicalPath="/conference-proceding"
        keywords={[
          "Conference paper writing publication",
          "Research paper writing and publication",
          "SCI paper writing bhopal",
          "IEEE paper writing",
          "Scopus paper writing bhopal",
          "Paper Writing Bhopal"
        ]}
      />
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Conference Proceedings</h1>
          <p className="text-lg text-gray-600">Access proceedings and abstracts from our conferences</p>
        </div>

        {/* Conference Selection */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Select Conference</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {conferences.map((conference, index) => (
              <div
                key={conference.id}
                onClick={() => setSelectedConference(index)}
                className={`p-4 rounded-lg cursor-pointer transition-all duration-200 ${
                  selectedConference === index
                    ? 'bg-indigo-600 text-white shadow-lg scale-105'
                    : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md hover:shadow-lg'
                }`}
              >
                <h3 className="font-semibold text-lg mb-2">{conference.name}</h3>
                <div className="flex items-center text-sm mb-1">
                  <Calendar className="w-4 h-4 mr-2" />
                  <span>{conference.date}</span>
                </div>
                <div className="flex items-center text-sm">
                  <MapPin className="w-4 h-4 mr-2" />
                  <span>{conference.location}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Selected Conference Details */}
        <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
          <div className="border-b border-gray-200 pb-4 mb-6">
            <h2 className="text-2xl font-bold text-gray-900">{currentConference.name}</h2>
            <p className="text-gray-600 mt-2">{currentConference.description}</p>
            <div className="flex items-center gap-4 mt-3 text-sm text-gray-500">
              <div className="flex items-center">
                <Calendar className="w-4 h-4 mr-1" />
                {currentConference.date}
              </div>
              <div className="flex items-center">
                <MapPin className="w-4 h-4 mr-1" />
                {currentConference.location}
              </div>
            </div>
          </div>

          {/* Proceedings Section */}
          <h3 className="text-xl font-semibold text-gray-800 mb-6">Proceedings</h3>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Conference Summary Card */}
            <div className="bg-gradient-to-br from-green-50 to-blue-50 rounded-lg p-6 border border-gray-200">
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-green-500 to-blue-500 rounded-lg mb-4 mx-auto">
                <FileText className="w-8 h-8 text-white" />
              </div>
              
              <h4 className="text-lg font-semibold text-gray-900 text-center mb-2">
                {currentConference.proceedings.summary.title}
              </h4>
              
              <p className="text-gray-600 text-center mb-4">
                {currentConference.proceedings.summary.description}
              </p>
              
              <div className="space-y-3">
                {/* <button 
                  onClick={() => window.open(currentConference.proceedings.summary.pdfLink, '_blank')}
                  className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                  <Download className="w-4 h-4" />
                  View PDF
                </button> */}
                
                <button
                  onClick={() => window.open(currentConference.proceedings.summary.paperLink, '_blank')}
                  className="w-full bg-white hover:bg-gray-50 text-indigo-600 font-medium py-2 px-4 rounded-lg border border-indigo-600 transition-colors flex items-center justify-center gap-2"
                >
                  <ExternalLink className="w-4 h-4" />
                  Paper Link
                </button>
              </div>
            </div>

            {/* Abstract Book Card */}
            <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-lg p-6 border border-gray-200">
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg mb-4 mx-auto">
                <FileText className="w-8 h-8 text-white" />
              </div>
              
              <h4 className="text-lg font-semibold text-gray-900 text-center mb-2">
                {currentConference.proceedings.abstracts.title}
              </h4>
              
              <p className="text-gray-600 text-center mb-4">
                {currentConference.proceedings.abstracts.description}
              </p>
              
              <div className="space-y-3">
                {/* <button 
                  onClick={() => window.open(currentConference.proceedings.abstracts.pdfLink, '_blank')}
                  className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                  <Download className="w-4 h-4" />
                  View PDF
                </button> */}
                
                <button
                  onClick={() => window.open(currentConference.proceedings.abstracts.paperLink, '_blank')}
                  className="w-full bg-white hover:bg-gray-50 text-indigo-600 font-medium py-2 px-4 rounded-lg border border-indigo-600 transition-colors flex items-center justify-center gap-2"
                >
                  <ExternalLink className="w-4 h-4" />
                  Paper Link
                </button>
              </div>
            </div>

            {/* Past Conferences Card */}
            <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-lg p-6 border border-gray-200">
              <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-r from-purple-500 to-green-500 rounded-lg mb-4 mx-auto">
                <History className="w-8 h-8 text-white" />
              </div>
              
              <h4 className="text-lg font-semibold text-gray-900 text-center mb-2">
                Past Conferences
              </h4>
              
              <p className="text-gray-600 text-center mb-4">
                Browse and manage completed conferences with full editing capabilities
              </p>
              
              <div className="space-y-3">
                {/* <button 
                  onClick={handlePastConferencesClick}
                  className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
                >
                  <History className="w-4 h-4" />
                  View Past Conferences
                </button> */}
                
                <button
                  onClick={handlePastConferencesClick}
                  className="w-full bg-white hover:bg-gray-50 text-indigo-600 font-medium py-2 px-4 rounded-lg border border-indigo-600 transition-colors flex items-center justify-center gap-2"
                >
                  <ExternalLink className="w-4 h-4" />
                  Manage Conferences
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information */}
        {/* <div className="bg-white rounded-xl shadow-lg p-6">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">Need Help?</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-4 bg-gray-50 rounded-lg">
              <h4 className="font-medium text-gray-900 mb-2">Technical Support</h4>
              <p className="text-gray-600 text-sm mb-3">Having trouble accessing proceedings?</p>
              <button className="text-indigo-600 hover:text-indigo-700 font-medium text-sm">
                Contact Support →
              </button>
            </div>
            <div className="p-4 bg-gray-50 rounded-lg">
              <h4 className="font-medium text-gray-900 mb-2">Citation Guide</h4>
              <p className="text-gray-600 text-sm mb-3">Learn how to properly cite papers</p>
              <button className="text-indigo-600 hover:text-indigo-700 font-medium text-sm">
                View Guide →
              </button>
            </div>
          </div>
        </div> */}
      </div>
    </div>
    <NewFooter />
  </>
  );
};

export default ConferenceProceedings;